import React from "react";
import FooterContact from "./FooterContact";
import FooterCopyRight from "./FooterCopyRight";
import FooterNavigation from "./FooterNavigation";
import FooterStaticLinks from "./FooterStaticLinks";

export default function Footer({whatsappBot}) {
  return (
    <React.Fragment>
      <FooterNavigation />
      <FooterContact />
      <FooterStaticLinks />
      <FooterCopyRight 
        whatsappBot={whatsappBot }
      />
    </React.Fragment>
  );
}
